export default __webpack_public_path__ + "static/media/6.08438c9a.png";